// extracted by css-extract-rspack-plugin
export default {"root":"z3URy","icon":"d5Cx3","loader":"V82C8"};